import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAppContext } from '../Context/AppProvider'; // Adjust path if needed

const ProtectedRoute = ({ children }) => {
  const { isAdminLoggedIn } = useAppContext();
 const navigate = useNavigate()
 const location = useLocation()
  if (!isAdminLoggedIn) {
    // User is not logged in, redirect to the login page
    // `replace` prop ensures the user can't go back to the protected page using the browser back button
    return <Navigate to="/admin/login" replace />;
  }
  console.log(location.pathname);
  
if (location.pathname == '/admin') {
  return <Navigate to={'/admin/docs'} replace/>
}
  return children;
}


export default ProtectedRoute;